import { render } from "./AudioUploader.vue?vue&type=template&id=97ffb44c"
import script from "./AudioUploader.vue?vue&type=script&lang=js"
export * from "./AudioUploader.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__